'use client'

import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { Card } from '@/entities/auth'
import { useSignUpGuestStore } from '@/features/sign-up'
import { type PhoneVerificationResult } from '@/features/verify-identity'
import { Slot, WithProvider, DialogProvider } from '@/shared/lib'
import {
  PassportEmailVerification,
  PhoneVerification,
} from '@/widgets/verification'

import { VerificationDialogs } from './verification-dialogs'
import { useSignUpGuest } from '../../lib/sign-up-guest'
import { useVerificationDialog } from '../../lib/verification-dialogs'

const Verification = () => {
  const t = useTranslations()

  const { actions, info, verification } = useSignUpGuestStore()
  const { open } = useVerificationDialog()

  const { handleSignUp } = useSignUpGuest({
    onSuccess: dialog => {
      open(dialog)
    },
  })

  const handleSuccessPhoneVerification = ({
    certNum,
    phoneNumber,
  }: PhoneVerificationResult) => {
    actions.updateVerification({ phoneNumber, certNum })

    handleSignUp()
  }

  const handleSuccessPassportVerification = () => {
    handleSignUp()
  }

  useEffect(() => {
    actions.updateVerification({
      phoneNumber: '',
      certNum: '',
      contactNumber: '',
      passportImageUrl: '',
      ocrToken: '',
      emailCertToken: '',
    })
  }, [])

  return (
    <>
      <Card progress={75}>
        <Slot name="title">{t('verification.title')}</Slot>
        <Slot name="description">{t('verification.description')}</Slot>
        <Slot name="children">
          <div className="space-y-15">
            <PhoneVerification
              onSuccess={handleSuccessPhoneVerification}
              className="mb-10"
            />

            <PassportEmailVerification />
          </div>
        </Slot>
      </Card>

      <VerificationDialogs
        passportDefaultValues={{
          contactNumber: verification?.contactNumber,
          passportImageUrl: verification?.passportImageUrl,
        }}
        onSuccess={handleSuccessPassportVerification}
        email={info.email}
      />
    </>
  )
}

export const SignUpGuestVerification = WithProvider({
  Component: Verification,
  Provider: DialogProvider,
})
